import * as types from 'store/modules/poll/mutation-types'
import poll from 'api/poll'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    polls: {
      total: 0,
      rows: []
    },
    oldPolls: {
      total: 0,
      rows: []
    },
    pathImage: {
      save: '',
      load: ''
    }
  },
  getters: {
    [types.GET_POLLS] (state) {
      return state.polls
    },
    [types.GET_OLD_POLLS] (state) {
      return state.oldPolls
    },
    [types.GET_PATH_IMAGE] (state) {
      return state.pathImage
    }
  },
  mutations: {
    [types.RESET_POLLS] (state) {
      state.polls = { total: 0, rows: [] }
    },
    [types.SET_POLLS] (state, polls) {
      state.polls.rows = state.polls.rows.concat(polls.rows)
    },
    [types.RESET_OLD_POLLS] (state) {
      state.oldPolls = { total: 0, rows: [] }
    },
    [types.SET_OLD_POLLS] (state, oldPolls) {
      state.oldPolls.rows = state.oldPolls.rows.concat(oldPolls.rows)
    },
    [types.SET_PATH_IMAGE] (state, data) {
      state.pathImage = data
    },
    [types.SAVE_POLL_CHOICE] (state, pollChoice) {
      let rowIndex = state.polls.rows.map(function (poll) {
        return poll.codpoll
      }).indexOf(pollChoice.codpoll)
      state.polls.rows[rowIndex].choices.push(pollChoice)
    },
    [types.SAVE_POLL] (state, poll) {
      state.polls.rows.push(poll)
    },
    [types.SAVE_SELECT_CHOICE] (state, pollChoice) {
      let rowPollIndex = state.polls.rows.map(function (poll) {
        return poll.codpoll
      }).indexOf(pollChoice.codpoll)
      let choices = state.polls.rows[rowPollIndex].choices
      let flgmulticho = state.polls.rows[rowPollIndex].flgmulticho
      if (flgmulticho === 'N') {
        for (var i = 0; i < choices.length; i++) {
          var choice = state.polls.rows[rowPollIndex].choices[i]
          if (choice.selected === 'Y' && choice.numseq !== pollChoice.numseq) {
            state.polls.rows[rowPollIndex].choices[i].selected = 'N'
            state.polls.rows[rowPollIndex].choices[i].number = choices[i].number - 1
            pollChoice.totalVote = pollChoice.totalVote - 1
          }
        }
      }
      let rowChoiceIndex = choices.map(function (choice) {
        return choice.numseq
      }).indexOf(pollChoice.numseq)
      state.polls.rows[rowPollIndex].choices[rowChoiceIndex].selected = pollChoice.selected
      state.polls.rows[rowPollIndex].choices[rowChoiceIndex].number = pollChoice.number
      state.polls.rows[rowPollIndex].totalVote = pollChoice.totalVote
    }
  },
  actions: {
    [types.RECEIVED_POLLS_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      poll.receivedPollsInfiniteLoading(params.searchParams)
        .then((response) => {
          const pollObj = JSON.parse(response.request.response)
          commit(types.SET_POLLS, pollObj)
          triggerInfinite({ length: pollObj.rows.length, $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve poll again', message)
          poll.receivedPollsInfiniteLoading(params.searchParams)
            .then((response) => {
              const pollObj2 = JSON.parse(response.request.response)
              commit(types.SET_POLLS, pollObj2)
              triggerInfinite({ length: pollObj2.rows.length, $state: params.$state })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.RECEIVED_OLD_POLLS_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      poll.receivedOldPollsInfiniteLoading(params.searchParams)
        .then((response) => {
          const oldPollObj = JSON.parse(response.request.response)
          commit(types.SET_OLD_POLLS, oldPollObj)
          triggerInfinite({ length: oldPollObj.rows.length, $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_PATH_IMAGE] ({ commit }) {
      poll.getPathImage()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_PATH_IMAGE, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve poll_path_image again', message)
          poll.getPathImage()
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_PATH_IMAGE, data2)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.POST_POLL] ({ commit }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          let sendParams = params.sendParams
          let pollParams = params.pollParams
          poll.postPoll(sendParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              pollParams.codpoll = parseInt(data.codpoll)
              commit(types.SAVE_POLL, pollParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    },
    [types.POST_CHOICE] ({ commit }, params) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      let sendParams = params.sendParams
      let choiceParams = params.choiceParams
      poll.postChoice(sendParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          choiceParams.numseq = parseInt(data.numseq)
          commit(types.SAVE_POLL_CHOICE, choiceParams)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_SELECT_CHOICE] ({ commit }, params) {
      let sendParams = params.sendParams
      let choiceParams = params.choiceParams
      if (choiceParams.selected === 'N') {
        choiceParams.selected = 'Y'
        choiceParams.number = parseInt(choiceParams.number) + 1
        choiceParams.totalVote = parseInt(choiceParams.totalVote) + 1
      } else if (choiceParams.selected === 'Y') {
        choiceParams.selected = 'N'
        choiceParams.number = parseInt(choiceParams.number) - 1
        choiceParams.totalVote = parseInt(choiceParams.totalVote) - 1
      }
      poll.postSelectChoice(sendParams)
        .then((response) => {
          commit(types.SAVE_SELECT_CHOICE, choiceParams)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.DELETE_CHOICE] ({ commit }, sendParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmDelete'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          poll.deleteChoice(sendParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/poll/index.js